export default "__VITE_ASSET__B_chP74S__"